import { createAction } from "redux-smart-actions";
import { getSaga } from "src/request/get";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import {
  AgreementDto,
  AgreementTypeDto,
  CityDto,
  ContactDto,
  CountryDto,
  CurrencyDto,
  DataTypeDto,
  DistrictDto,
  ModuleTypeDto,
  NeighbourhoodDto,
  PeriodTypeDto,
  SectorDto,
  SubDistrictDto,
  TimezoneDto,
} from "./type";
import { putSaga } from "src/request/put";
import { deleteSaga } from "src/request/delete";
import { postSaga } from "src/request/post";
import { takeLatest } from "redux-saga/effects";

export const getPeriodTypes = createAction(
  "GET_PERIOD_TYPES",
  ({ payload }: SagaActionParams<PeriodTypeDto[]>) => ({
    payload,
    url: "/api/system/periods",
  })
);
export const getModuleTypes = createAction(
  "GET_MODULE_TYPES",
  ({ payload }: SagaActionParams<ModuleTypeDto[]>) => ({
    payload,
    url: "/api/system/moduletypes",
  })
);
export const getContacts = createAction(
  "GET_CONTACTS",
  ({ payload }: SagaActionParams<ContactDto[]>) => ({
    payload,
    url: "/api/admin/contacts",
  })
);
export const getDataTypes = createAction(
  "GET_DATA_TYPES",
  ({ payload }: SagaActionParams<DataTypeDto[]>) => ({
    payload,
    url: "/api/system/datatypes",
  })
);
export const getCurrencies = createAction(
  "GET_CURRENCIES",
  ({ payload }: SagaActionParams<CurrencyDto[]>) => ({
    payload,
    url: "/api/system/currencies",
  })
);
export const getTimeZone = createAction(
  "GET_TIME_ZONE",
  ({ payload }: SagaActionParams<TimezoneDto[]>) => ({
    payload,
    url: "/api/system/timezones",
  })
);
export const getSectors = createAction(
  "GET_SECTORS",
  ({ payload }: SagaActionParams<SectorDto[]>) => ({
    payload,
    url: "/api/system/sectors",
  })
);
export const getCountries = createAction(
  "GET_COUNTRIES",
  ({ payload }: SagaActionParams<CountryDto[]>) => ({
    payload,
    url: "/api/system/countries",
  })
);
export const getCities = createAction(
  "GET_CITIES",
  ({ payload, id }: SagaActionParams<CityDto[]>) => ({
    payload,
    url: "/api/system/cities/?countyId=" + id,
  })
);
export const getDistricts = createAction(
  "GET_DISTRICTS",
  ({ payload, id }: SagaActionParams<DistrictDto[]>) => ({
    payload,
    url: "/api/system/districts?CityId=" + id,
  })
);
export const getSubDistricts = createAction(
  "GET_SUBDISTRICTS",
  ({ payload, id }: SagaActionParams<SubDistrictDto[]>) => ({
    payload,
    url: "/api/system/subdistricts?DistrictId=" + id,
  })
);
export const getNeighbourhoods = createAction(
  "GET_NEIGHBOURHOOD",
  ({ payload, id }: SagaActionParams<NeighbourhoodDto[]>) => ({
    payload,
    url: "/api/system/neighbourhoods?SubDistrictId=" + id,
  })
);

/*AGREEMENT*/
export const getAgreementTypes = createAction(
  "GET_AGREEMENT_TYPES",
  ({ payload }: SagaActionParams<AgreementTypeDto[]>) => ({
    payload,
    url: "/api/admin/adminpolicies/get-policy-types",
  })
);
export const getAgreements = createAction(
  "GET_AGREEMENTS",
  ({ payload }: SagaActionParams<AgreementDto[]>) => ({
    payload,
    url: "/api/admin/adminpolicies",
  })
);

const systemSaga = [
  takeLatest<any>(
    getPeriodTypes.toString(),
    (payload: SagaGenericParams<PeriodTypeDto[]>) =>
      getSaga<PeriodTypeDto[]>(payload)
  ),
  takeLatest<any>(
    getModuleTypes.toString(),
    (payload: SagaGenericParams<ModuleTypeDto[]>) =>
      getSaga<ModuleTypeDto[]>(payload)
  ),
  takeLatest<any>(
    getContacts.toString(),
    (payload: SagaGenericParams<ContactDto[]>) => getSaga<ContactDto[]>(payload)
  ),
  takeLatest<any>(
    getDataTypes.toString(),
    (payload: SagaGenericParams<DataTypeDto[]>) =>
      getSaga<DataTypeDto[]>(payload)
  ),
  takeLatest<any>(
    getCurrencies.toString(),
    (payload: SagaGenericParams<CurrencyDto[]>) =>
      getSaga<CurrencyDto[]>(payload)
  ),
  takeLatest<any>(
    getTimeZone.toString(),
    (payload: SagaGenericParams<TimezoneDto[]>) =>
      getSaga<TimezoneDto[]>(payload)
  ),
  takeLatest<any>(
    getSectors.toString(),
    (payload: SagaGenericParams<SectorDto[]>) => getSaga<SectorDto[]>(payload)
  ),
  takeLatest<any>(
    getCountries.toString(),
    (payload: SagaGenericParams<CountryDto[]>) => getSaga<CountryDto[]>(payload)
  ),
  takeLatest<any>(
    getCities.toString(),
    (payload: SagaGenericParams<CityDto[]>) => getSaga<CityDto[]>(payload)
  ),
  takeLatest<any>(
    getDistricts.toString(),
    (payload: SagaGenericParams<DistrictDto[]>) =>
      getSaga<DistrictDto[]>(payload)
  ),
  takeLatest<any>(
    getSubDistricts.toString(),
    (payload: SagaGenericParams<SubDistrictDto[]>) =>
      getSaga<SubDistrictDto[]>(payload)
  ),
  takeLatest<any>(
    getNeighbourhoods.toString(),
    (payload: SagaGenericParams<NeighbourhoodDto[]>) =>
      getSaga<NeighbourhoodDto[]>(payload)
  ),
  /*AGREEMENT*/
  takeLatest<any>(
    getAgreementTypes.toString(),
    (payload: SagaGenericParams<AgreementTypeDto[]>) =>
      getSaga<AgreementTypeDto[]>(payload)
  ),
  takeLatest<any>(
    getAgreements.toString(),
    (payload: SagaGenericParams<AgreementDto[]>) =>
      getSaga<AgreementDto[]>(payload)
  ),
];

export default systemSaga;
